// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d529b6f2","455":"7a304cb2","977":"be01fa09"}[chunkId] + ".chunk.js";
};